<template>
  <Breadcrumbs
      title="Order Request Schedule Report"
      :breadcrumbs="[
      { label: 'Reports', path: '' },
      { label: 'Order Request Schedule Report', path: '/order-request-schedule-report' },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <dispatchSummeryForm />
    </div>
  </div>
</template>
  
<script>
import dispatchSummeryForm from "@/pages/report/po_schedule/posheduleReportTable.vue";

export default {
  name: 'indexList',
  components: {
    dispatchSummeryForm,

  },
}
</script>
  